import React, { useRef } from "react";

/**
 * Wraps any element (button, Link, etc.) with a subtle magnetic pointer-follow
 * effect. Purely additive — falls back to a plain wrapper on touch devices.
 */
export default function MagneticButton({ children, className = "", strength = 18, as: Tag = "div", ...rest }) {
  const ref = useRef(null);

  const handleMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const relX = e.clientX - rect.left - rect.width / 2;
    const relY = e.clientY - rect.top - rect.height / 2;
    el.style.transform = `translate(${(relX / rect.width) * strength}px, ${(relY / rect.height) * strength}px)`;
  };

  const handleLeave = () => {
    const el = ref.current;
    if (!el) return;
    el.style.transform = "translate(0, 0)";
  };

  return (
    <Tag
      ref={ref}
      className={`va-magnetic ${className}`}
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
      {...rest}
    >
      {children}
    </Tag>
  );
}
